import { render, staticRenderFns } from "./text_fitter.vue?vue&type=template&id=190eb336&scoped=true&"
import script from "./text_fitter.vue?vue&type=script&lang=js&"
export * from "./text_fitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190eb336",
  null
  
)

export default component.exports